import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ViewFiatTransaction = () => {
  const { fiatWithdrawId } = useParams();
  const [fiatData, setFiatData] = useState({});
  const [txHash, setTxHash] = useState("");
  const token = localStorage.getItem("token");
  const navigate = useNavigate()

  // Fetch Fiat Transaction Details
  useEffect(() => {
    const fetchFiatData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/merchant-app-tx/view-fiat-withdrawl?fiatWithdrawId=${fiatWithdrawId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("response of fiat get", response);

        setFiatData(response?.data?.fiatData);
      } catch (error) {
        console.error("Error fetching fiat details:", error);
        toast.error("Failed to fetch fiat transaction details");
      }
    };

    fetchFiatData();
  }, [fiatWithdrawId, token]);

  // Submit TX Hash if status is NOT SUCCESS
  const submitTxHash = async () => {
    if (!txHash) {
      toast.warn("Please enter Tx Hash");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/merchant-app-tx/admin-fiat-transfer`,
        { fiatWithdrawId: fiatWithdrawId, txHash },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("response post", response);

      if (response?.data?.success) {
        toast.success("Fiat fund transfer succesfully!");
        navigate('/fiat-transaction')
        setFiatData(response?.data?.fiatData);
      }
    } catch (error) {
      console.error("Error submitting tx hash:", error);
      toast.error("Failed to submit Tx Hash");
    }
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <h1 className="m-3">Fiat Transaction Details</h1>

        <div className="card card-primary m-3">
          <div className="card-body view-page">
            {fiatData && (
              <>
                <div className="user-info">
                  <strong>Status:</strong> {fiatData?.status}
                </div>
                <br />

                <div className="user-info">
                  <strong>Merchant Name:</strong> {fiatData?.merchantId?.name}
                </div>
                <br />

                <div className="user-info">
                  <strong>App Name:</strong> {fiatData?.appsId?.name}
                </div>
                <br />

                <div className="user-info">
                  <strong>Total Fiat Balance:</strong>{" "}
                  {fiatData?.appsId?.totalFiatBalance}
                </div>
                <br />

                <div className="user-info">
                  <strong>Withdraw Amount:</strong> {fiatData?.withdrawlAmount}
                </div>
                <br />

                <div className="user-info">
                  <strong>Currency:</strong> {fiatData?.currency}
                </div>
                <br />

                <div className="user-info">
                  <strong>Crypto Value:</strong> {fiatData?.cryptoValue}
                </div>
                <br />

                <div className="user-info">
                  <strong>Wallet Address:</strong> {fiatData?.walletAddress}
                </div>
                <br />

                <div className="user-info">
                  <strong>Note:</strong> {fiatData?.walletAddress}
                </div>
                <br />

                <div className="user-info">
                  <strong>Created At:</strong> {fiatData?.createdAt}
                </div>
                <br />

                {/* Show TX Hash & Submit Button only if NOT SUCCESS */}
                {fiatData.status !== "SUCCESS" && (
                  <div className="mt-4">
                    <label>
                      <strong>Enter Tx Hash</strong>
                    </label>
                    <input
                      type="text"
                      className="form-control mt-2"
                      placeholder="Enter transaction hash"
                      value={txHash}
                      onChange={(e) => setTxHash(e.target.value)}
                    />

                    <button
                      className="btn btn-primary mt-3"
                      onClick={submitTxHash}
                    >
                      Submit Tx Hash
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewFiatTransaction;
